"use strict";
import { Loading } from 'element-ui';
import { Notification } from 'element-ui'
import Vue from 'vue';
import axios from "axios";
import { getToken } from '@/plugins/auth' // getToken from cookie

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
let config = {
    //baseURL: "http://localhost:2222/"
    baseURL: "https://zz.api.akcywy.com"
    // || process.env.apiUrl || ""
    // timeout: 60 * 1000, // Timeout
    // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);
let loadingInstance = null
let notificationInstance = null
_axios.interceptors.request.use(
    function (config) {
        if (getToken()) {
            config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
        }
        config.headers['Content-Type'] = 'application/json'
        // Do something before request is sent
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);
// Add a response interceptor
_axios.interceptors.response.use(
    response => {
        if (response.status < 200 || response.status > 300) {
            return Promise.reject(response);
        } else {
            return response.data
        }
    },
    function (error) {
        return Promise.reject(error);
    }
);

export default _axios;
